import React from 'react';
import {useQueryClient} from "react-query";

import { useUnitsOfMeasure, useSettings, useMenuItems } from "../services/settings";
import { fetch as fetchSettings } from "../services/settings/useSettings";
import { fetch as fetchMenuItems } from "../services/settings/useMenuItems";

const InitializeCache = (props) => {
  const {SystemData, onChange} = props;
  const queryClient = useQueryClient();

  //Initialize caches wiith initial values
  useUnitsOfMeasure({ queryClient, useCache: true });

  Promise.all([
    new Promise((resolve) => {
      fetchMenuItems({ queryClient, useCache: true}).then(menuItems => {
        if ((!SystemData.menuItems || !Array.isArray(SystemData.menuItems) || SystemData.menuItems.length <= 0) && Array.isArray(menuItems) && menuItems.length > 0) {
          resolve({menuItems});
        } else {
          resolve({});
        }
      });
    }),
    new Promise((resolve) => {
      fetchSettings({queryClient, extraKeys: ["COLOURS"], useCache: true}).then(colours => {
        if (!SystemData.colours && colours) {
          resolve({colours});
        } else {
          resolve({});
        }
      })
    })
  ]).then((changeArray) => {
    let changes = {};
    changeArray.forEach(change => {
      changes = {...changes, ...change};
    });
    if (changes && changes.colours && changes.menuItems) onChange(changes);
  })

  return (<div style={{display:"none"}}></div>);
};

export default InitializeCache;
